(function() {
  'use strict';
  
  function initBestsellersCarousel() {
    // Find all bestsellers sections on the page
    const bestsellersSections = document.querySelectorAll('.shopify-section--bestsellers');
    
    bestsellersSections.forEach((sectionElement) => {
      const carousel = sectionElement.querySelector('[data-carousel-track]');
      if (!carousel) return;

      const prevBtn = sectionElement.querySelector('.bestsellers__nav--prev');
      const nextBtn = sectionElement.querySelector('.bestsellers__nav--next');
      const dotsContainer = sectionElement.querySelector('[data-carousel-dots]');
      const slides = carousel.querySelectorAll(".bestsellers__slide");
      
      if (slides.length === 0) return;
      
      // If buttons don't exist, don't initialize carousel
      if (!prevBtn || !nextBtn) return;

      let currentIndex = 0;
      let maxIndex = 0;
      let slidesPerView = 4; // Track actual slides that fit in viewport

      function updateCarousel() {
        if (slides.length === 0) return;
        
        // Wait for slides to have width
        if (slides[0].offsetWidth === 0) {
          requestAnimationFrame(updateCarousel);
          return;
        }
        
        const slideWidth = slides[0].offsetWidth;
        const trackWrapper = carousel.parentElement; // This is .bestsellers__track-wrapper
        const outerWrapper = trackWrapper.parentElement; // This is .bestsellers__wrapper with padding
        const track = carousel;
        
        // Get the visible width from track wrapper (already excludes outer padding)
        const visibleWidth = trackWrapper.offsetWidth;
        
        // Dynamically calculate gap from computed style
        const trackStyle = getComputedStyle(track);
        const gap = parseFloat(trackStyle.gap) || 24;
        
        // Get products per row from CSS variable (this changes with screen size)
        const productsPerView = parseInt(getComputedStyle(sectionElement).getPropertyValue('--bestsellers-products-per-row')) || 4;
        
        // Calculate how many COMPLETE slides fit in the visible area
        slidesPerView = Math.floor((visibleWidth + gap) / (slideWidth + gap));
        
        // Ensure we show at least 1 slide
        slidesPerView = Math.max(1, slidesPerView);
        
        const totalSlides = slides.length;
        
        // Calculate total track width
        const totalTrackWidth = (slideWidth + gap) * totalSlides - gap;
        
        // Calculate how many pages we need
        maxIndex = Math.max(0, Math.ceil(totalSlides / slidesPerView) - 1);
        
        // If we're on a page beyond maxIndex, go back to maxIndex
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        
        let scrollAmount;
        
        // Calculate scroll amount
        if (currentIndex === maxIndex) {
          // Last page: show the last slidesPerView complete slides
          const lastPageStartIndex = Math.max(0, totalSlides - slidesPerView);
          scrollAmount = lastPageStartIndex * (slideWidth + gap);
          
          // Make sure we don't scroll past the actual content
          const maxPossibleScroll = Math.max(0, totalTrackWidth - visibleWidth);
          scrollAmount = Math.min(scrollAmount, maxPossibleScroll);
        } else {
          // Regular pages: scroll by slidesPerView slides
          scrollAmount = currentIndex * slidesPerView * (slideWidth + gap);
        }
        
        track.style.transform = `translateX(-${scrollAmount}px)`;

        if (dotsContainer) {
          const dots = dotsContainer.querySelectorAll(".bestsellers__dot");
          dots.forEach((dot, index) => {
            dot.classList.toggle("active", index === currentIndex);
          });
        }

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex === maxIndex;
      }

      function createDots() {
        if (!dotsContainer) return;
        
        // Clear existing dots
        dotsContainer.innerHTML = '';
        
        // Create dots based on maxIndex + 1 (number of pages)
        for (let i = 0; i <= maxIndex; i++) {
          const dot = document.createElement('button');
          dot.className = 'bestsellers__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => goToSlide(i));
          dotsContainer.appendChild(dot);
        }
      }

      function goToSlide(index) {
        currentIndex = Math.max(0, Math.min(index, maxIndex));
        updateCarousel();
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          goToSlide(currentIndex + 1);
        });
      }

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // Reset to first page on resize to avoid being stuck on invalid page
          const oldMaxIndex = maxIndex;
          
          // Recalculate everything
          updateCarousel();
          
          // Always recreate dots on resize as the number of pages likely changed
          createDots();
          
          // If current index is beyond new maxIndex, go back to a valid page
          if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
            updateCarousel();
          }
        }, 250);
      });

      // Initialize carousel - try multiple times to ensure it works
      function tryInit() {
        if (slides[0].offsetWidth > 0) {
          updateCarousel();
          createDots();
        } else {
          setTimeout(tryInit, 50);
        }
      }

      // Try to initialize immediately
      tryInit();

      // Also try after a short delay to handle image loading
      setTimeout(() => {
        tryInit();
      }, 200);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestsellersCarousel);
  } else {
    initBestsellersCarousel();
  }
})();
